const API = "https://strapi.us-fx.pro/api";

export async function getArticles() {
  const res = await fetch(`${API}/articles?populate=*`);
  const data = await res.json();
  return data.data;
}

export async function getArticle(documentId) {
  const res = await fetch(
    `${API}/articles/${documentId}?populate=*`
  );
  const data = await res.json();
  return data.data;
}